import React from 'react'
import { PRAXIS } from 'common/shopInfo'
import { useSelector } from 'react-redux'

export const BreadcrumbsSchema = ({ list }) => {
  const format = useSelector(store => store.data.format)

  const domain = format === PRAXIS ? 'www.praxis.nl' : 'www.brico.be'
  const itemListElement = list.map((b, i) => {
    return {
      '@type': 'ListItem',
      position: i + 1,
      name: b.caption,
      item: `https://${domain}${b.link}`
    }
  })

  // DO NOT LEAVE COMMENTS INSIDE JSON!!!
  const json = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement
  }
  return (
    <script
      style={{ display: 'none' }}
      type='application/ld+json'
      dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }}
    />
  )
}
